import { Suspense } from 'react';
import { Link } from 'react-router-dom';
import Header from '../../../components/feature/Header';
import Footer from '../../../components/feature/Footer';
import FloatingButtons from '../../../components/feature/FloatingButtons';

const PeriyodikKontrollerPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
      <section className="relative h-[60vh] min-h-[500px] bg-gradient-to-r from-emerald-900 via-emerald-800 to-teal-900 overflow-hidden mt-20">
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30"></div>
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-32 h-32 border-2 border-white rounded-full animate-pulse"></div>
          <div className="absolute bottom-20 right-20 w-40 h-40 border-2 border-white rounded-full animate-pulse"></div>
        </div>
        
        <div className="relative z-10 container mx-auto px-6 h-full flex items-center">
          <div className="text-white max-w-3xl">
            <div className="flex items-center mb-6">
              <div className="w-16 h-16 flex items-center justify-center mr-4">
                <i className="ri-tools-line text-6xl text-emerald-300"></i>
              </div>
              <h1 className="text-5xl md:text-6xl font-bold">Periyodik Kontroller</h1>
            </div>
            <p className="text-xl md:text-2xl text-emerald-100 leading-relaxed">
              İş yerlerinde güvenli çalışma ortamı için düzenli periyodik kontrol ve test hizmetleri
            </p>
          </div>
        </div>
      </section>

      {/* Main Content */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          {/* Services Grid */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">Periyodik Kontrol Hizmetlerimiz</h2>
              <p className="text-gray-700 text-lg max-w-3xl mx-auto">
                İş ekipmanları ve sistemlerin yasal periyotlarda kontrolü ve test edilmesi
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-8 auto-rows-fr">
              {/* Card 1 */}
              <div className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-8 border border-emerald-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-emerald-500 to-emerald-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-flashlight-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Elektrik Tesisatı Kontrolü</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  Elektrik tesisatlarınızın periyodik kontrollerini yaparak, elektrik kaynaklı iş kazalarını önlüyoruz.
                </p>
              </div>

              {/* Card 2 */}
              <div className="bg-gradient-to-br from-teal-50 to-teal-100 rounded-2xl p-8 border border-teal-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-teal-500 to-teal-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-fire-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">Yangın Sistemleri Kontrolü</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  Yangın algılama, söndürme ve ihbar sistemlerinizin düzenli kontrollerini gerçekleştiriyoruz.
                </p>
              </div>

              {/* Card 3 */}
              <div className="bg-gradient-to-br from-cyan-50 to-cyan-100 rounded-2xl p-8 border border-cyan-200 hover:shadow-xl transition-all duration-300 transform hover:-translate-y-2 flex flex-col h-full">
                <div className="w-20 h-20 bg-gradient-to-br from-cyan-500 to-cyan-600 rounded-full flex items-center justify-center mx-auto mb-6">
                  <div className="w-12 h-12 flex items-center justify-center">
                    <i className="ri-shield-check-line text-3xl text-white"></i>
                  </div>
                </div>
                <h3 className="text-2xl font-bold text-gray-800 mb-4 text-center">İş Ekipmanları Kontrolü</h3>
                <p className="text-gray-700 leading-relaxed text-center flex-grow">
                  Vinç, forklift, platform gibi iş ekipmanlarının periyodik muayene ve testlerini yapıyoruz.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Services */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Diğer Kontrol Hizmetlerimiz</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
              {[
                { icon: 'ri-arrow-up-line', title: 'Asansör Kontrolü', desc: 'Yıllık periyodik kontroller' },
                { icon: 'ri-gas-station-line', title: 'Basınçlı Kaplar', desc: 'Kazan ve kompresör testleri' },
                { icon: 'ri-shield-line', title: 'Topraklama Ölçümü', desc: 'Elektrik topraklama kontrolü' },
                { icon: 'ri-building-line', title: 'Baca Gazı Analizi', desc: 'Emisyon ölçüm ve raporlama' }
              ].map((item, index) => (
                <div key={index} className="bg-gradient-to-br from-gray-50 to-gray-100 rounded-2xl p-6 text-center border-2 border-gray-200 hover:shadow-lg transition-all duration-300 transform hover:-translate-y-1">
                  <div className="w-16 h-16 flex items-center justify-center mx-auto mb-4">
                    <i className={`${item.icon} text-5xl text-emerald-600`}></i>
                  </div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">{item.title}</h4>
                  <p className="text-sm text-gray-700">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Standards Section */}
          <div className="mb-20 bg-gradient-to-br from-gray-50 to-gray-100 rounded-3xl p-12 border-2 border-gray-200">
            <div className="text-center mb-10">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Kontrol Standartlarımız</h2>
              <p className="text-gray-700 text-lg max-w-2xl mx-auto">
                Tüm periyodik kontrollerimiz yasal mevzuat ve standartlara uygun olarak gerçekleştirilmektedir
              </p>
            </div>

            <div className="grid grid-cols-2 md:grid-cols-4 gap-6">
              {[
                { standard: 'TS EN 60204', desc: 'Elektrik Güvenliği' },
                { standard: 'TS EN 12845', desc: 'Yangın Sistemleri' },
                { standard: 'TS 13624', desc: 'İş Ekipmanları' },
                { standard: 'TS EN 81', desc: 'Asansör Güvenliği' }
              ].map((item, index) => (
                <div key={index} className="bg-white rounded-2xl p-6 text-center shadow-lg border-2 border-gray-200">
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                    <i className="ri-file-text-line text-5xl text-orange-600"></i>
                  </div>
                  <p className="font-bold text-gray-900 text-lg">{item.standard}</p>
                  <p className="text-sm text-gray-700">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* Process Section */}
          <div className="mb-20">
            <div className="text-center mb-12">
              <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Kontrol Süreci</h2>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
              {[
                { step: '1', title: 'Planlama', desc: 'Kontrol takvimi oluşturma', icon: 'ri-calendar-line' },
                { step: '2', title: 'Ön İnceleme', desc: 'Ekipman ve sistem kontrolü', icon: 'ri-search-line' },
                { step: '3', title: 'Test ve Ölçüm', desc: 'Detaylı kontrol işlemleri', icon: 'ri-tools-line' },
                { step: '4', title: 'Raporlama', desc: 'Sonuç raporu ve belgeler', icon: 'ri-file-list-line' }
              ].map((item, index) => (
                <div key={index} className="bg-gradient-to-br from-emerald-50 to-emerald-100 rounded-2xl p-6 text-center border border-emerald-200">
                  <div className="w-16 h-16 bg-emerald-600 text-white rounded-full flex items-center justify-center font-bold text-2xl mx-auto mb-4">
                    {item.step}
                  </div>
                  <div className="w-12 h-12 flex items-center justify-center mx-auto mb-3">
                    <i className={`${item.icon} text-4xl text-emerald-600`}></i>
                  </div>
                  <h4 className="font-bold text-gray-900 text-lg mb-2">{item.title}</h4>
                  <p className="text-sm text-gray-700">{item.desc}</p>
                </div>
              ))}
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-emerald-600 via-emerald-700 to-teal-700 rounded-3xl p-12 md:p-16 text-center shadow-2xl">
            <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">Periyodik Kontrollerinizi Planlayın</h2>
            <p className="text-emerald-100 text-lg md:text-xl mb-8 max-w-2xl mx-auto">
              Akredite ekibimiz ve modern test cihazlarımızla iş yerinizde kapsamlı periyodik kontroller gerçekleştiriyoruz
            </p>
            <Link 
              to="/iletisim"
              className="inline-flex items-center bg-white text-emerald-600 px-10 py-5 rounded-2xl font-bold text-lg hover:bg-emerald-50 transition-all duration-300 transform hover:scale-105 shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>Teklif Alın</span>
              <div className="w-6 h-6 flex items-center justify-center ml-3">
                <i className="ri-arrow-right-line text-2xl"></i>
              </div>
            </Link>
          </div>
        </div>
      </section>

      <Footer />
      <FloatingButtons />
    </div>
  );
};

export default PeriyodikKontrollerPage;
